
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'billing-portal-ui',
  currentProjectVersion: 'static-1.2101',
  depVersions: {
  "billing-portal-ui": "static-1.2101",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.496",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.36",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8334",
  "hub-http-shared-msw-handlers": "static-1.10620",
  "hubspot-dlb": "static-2.1882",
  "portals-platform-bend-plugin": "static-1.22",
  "react-dlb": "static-1.88",
  "reselect": "static-3.12",
  "billing-portal-service-types": "static-1.1939",
  "commerce-products-lib": "static-1.10527",
  "commerce-shared-components-lib": "static-1.19223",
  "customer-data-objects": "static-1.7995",
  "customer-data-properties": "static-1.52599",
  "customer-data-property-utils": "static-1.8404",
  "data-fetching-client": "static-1.9958",
  "foundations-assets": "static-1.5188",
  "foundations-components": "static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "static-1.4779",
  "framework-data-table": "static-2.12552",
  "hub-http": "static-1.6516",
  "HubStyleTokens": "static-2.11793",
  "I18n": "static-7.1673",
  "meetings-icalendar-utils-lib": "static-1.939",
  "metrics-js": "static-1.9867",
  "object-builder-ui-client": "static-1.49674",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1457",
  "property-translator": "static-1.5698",
  "purchase-motions-components": "static-1.6367",
  "quartz-config": "static-1.1237",
  "quartz-core": "static-1.6678",
  "quartz-routing": "static-1.889",
  "quick-fetch": "static-1.4130",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17025",
  "redux": "static-4.76",
  "redux-toolkit": "static-1.78",
  "rpc-client-utils": "static-1.4970",
  "sanitize-text": "static-1.8458",
  "smart-property-lib": "static-1.8296",
  "styled-components": "static-2.95",
  "ui-addon-form-validation": "static-1.11286",
  "ui-addon-i18n": "static-1.11450",
  "ui-addon-iframeable": "static-1.9380",
  "ui-addon-react-router-dom": "static-1.9839",
  "ui-addon-upgrades": "static-9.18389",
  "UIComponents": "static-3.8739",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3621",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3736",
  "quartz-webpack": "static-1.3683",
  "bend-plugin-quartz-routing": "static-1.537",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.36",
  "HeadJS": "static-2.797",
  "quartz": "static-1.7459",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3445",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4294",
  "webpack-env": "static-1.54",
  "bender-build-tools": "static-1.3444",
  "commerce-permissions": "static-1.1080",
  "customer-data-tracking": "static-1.7185",
  "growth-payments-core": "static-1.26180",
  "hs-resources": "static-1.495",
  "hubspot-apollo-client": "static-1.5180",
  "immer": "static-1.101",
  "products-iframe-lib": "static-1.8593",
  "products-ui-components-shared-msw-handlers": "static-1.11002",
  "pulse": "static-1.933",
  "transmute": "static-2.97",
  "batch-promise": "static-1.1847",
  "crm_data": "static-4.92830",
  "cssUtils": "static-1.924",
  "customer-data-associations": "static-1.7630",
  "customer-data-objects-ui-components": "static-1.13333",
  "framework-data-schema-resolvers": "static-1.7196",
  "frontend-preferences-client": "static-1.8226",
  "graphql": "static-1.89",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9728",
  "HubStyle": "static-2.12100",
  "icons": "static-2.683",
  "payments-enrollment-embed-lib": "static-1.23832",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5557",
  "stripe-embedded-components": "static-1.8000",
  "StyleGuideUI": "static-3.502",
  "ui-addon-opt": "static-4.8667",
  "ui-images": "static-2.1249",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "inbound-db-properties-service-client": "static-1.4054",
  "ai-components-ui-library": "static-1.9717",
  "atom": "static-1.5390",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2784",
  "calling-global-api": "static-1.65625",
  "calling-internal-common": "static-1.31624",
  "calling-lifecycle-internal": "static-1.67007",
  "calling-lifecycle-messages": "static-1.59301",
  "conditional-properties-service-client": "static-1.4015",
  "crm-index-visualization-core": "static-1.4544",
  "crm-links": "static-1.6633",
  "crm-message-bus": "static-1.43762",
  "crm-pipelines-api-client-types": "static-1.4348",
  "customer-data-properties-shared-msw-handlers": "static-1.9947",
  "external-options-client-types": "static-1.4339",
  "file-manager-components": "static-1.24499",
  "formula-editor": "static-1.14770",
  "google-libphonenumber": "static-1.45",
  "hs-promise-utils": "static-1.5898",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4427",
  "multi-currency-client-types": "static-1.3910",
  "PatternValidationJS": "static-1.3196",
  "pipeline-validation-client-types": "static-1.4182",
  "property-value-citations": "static-1.3213",
  "quartz-i18n": "static-1.1134",
  "reference-resolvers-lite": "static-1.8406",
  "SharedI18nStrings": "static-1.183",
  "smart-data-capture-core": "static-1.142",
  "tiered-pricing": "static-1.1956",
  "topics-actions-lib": "static-1.469",
  "trial-components-library": "static-1.14109",
  "usage-tracker": "static-1.7637",
  "user-context": "static-1.5423",
  "zustand": "static-1.85",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.36",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2495",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.70",
  "react-virtualized": "static-2.107",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2645",
  "ui-fonts": "static-1.1055",
  "bend-plugin-foundations-theming": "static-1.3262",
  "foundations-theming-base": "static-1.3764",
  "stylex": "static-1.41",
  "customer-data-reference-ui-components": "static-1.13480",
  "customer-data-ui-utilities": "static-1.10132",
  "tasks-actions-lib": "static-1.127",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.80",
  "reference-resolvers": "static-1.8484",
  "reporting-data": "static-1.68826",
  "sanitize": "static-1.4775",
  "tanstack-virtual": "static-1.38",
  "ui-addon-draggable": "static-3.5063",
  "hs-locale-management": "static-1.295",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "interframe": "static-3.5058",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6051",
  "laboratory-lib": "static-3.7455",
  "merchandise-lib": "static-1.278",
  "onboarding-scopes": "static-1.6756",
  "purchase-motions-api": "static-1.6370",
  "signup-constants": "static-1.19631",
  "signup-ui-url-generator": "static-2.8364",
  "opentelemetry-fe-types": "static-1.74",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.879",
  "hubspotter-http": "static-1.4864",
  "jasmine": "static-4.4616",
  "jasmine-runner": "static-1.6754",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.449",
  "quartz-auth": "static-1.1134",
  "quartz-head": "static-1.1124",
  "quartz-test": "static-1.1134",
  "quartz-tracking": "static-1.838",
  "trellis-components": "static-1.2664",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "bend-plugin-chirp-manifest": "static-1.380",
  "chirp-fetch": "static-1.2197",
  "data-agent-kit": "static-1.651",
  "data-token-picker": "static-1.16891",
  "feedback-loader": "static-1.29813",
  "markdown-it": "static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10703",
  "fsm": "static-1.4053",
  "policy-lib": "static-1.7105",
  "react-colorpicker": "static-2.10521",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10766",
  "magpie-lib": "static-1.5755",
  "navigation-messaging": "static-1.8161",
  "salesImages": "static-1.565",
  "seat-types-lib": "static-1.727",
  "apollo-link-hub-http": "static-2.4959",
  "event-emitter": "static-1.1256",
  "framework-builder-read-service-client": "static-1.4220",
  "fdsr-migration-layer": "static-1.315",
  "hubspot-apollo-cache": "static-1.639",
  "sales-views-client-types": "static-1.4560",
  "bend-plugin-pulse": "static-1.436",
  "fast-json-patch": "static-1.70",
  "crm_universal": "static-1.22498",
  "customer-data-email": "static-1.18528",
  "native-integrations-shared-strings": "static-1.8080",
  "superstore": "static-1.5061",
  "sassPrefix": "static-1.195",
  "framework-data-schema-quick-fetch": "static-1.7101",
  "persist-promise": "static-1.4004",
  "copilot-toolkit": "static-1.11850",
  "growth-onboarding-confetti": "static-1.3364",
  "growth-onboarding-feedback-components": "static-1.6887",
  "growth-onboarding-reliability": "static-1.5384",
  "marketplace-ui-apps-core": "static-1.19260",
  "onboarding-tours": "static-1.17121",
  "stripe-connect-js": "static-1.76",
  "chatspot-core": "static-1.23032",
  "ContentUtils": "static-1.69126",
  "calling-error-reporting": "static-1.31631",
  "shared-worker-versioning": "static-1.11345",
  "calling-usage-tracker": "static-1.6839",
  "voice-sms-access-library": "static-1.2058",
  "conversations-skeleton-state": "static-1.7549",
  "react-immutable-render-mixin": "static-1.9",
  "crm-index-associations-lib": "static-1.6744",
  "location-customization-utils-lib": "static-1.10096",
  "restore-request-side-panel-lib": "static-1.1676",
  "breeze-engine-lib": "static-1.1737",
  "immerable": "static-1.4451",
  "video-components-external": "static-1.12148",
  "video-data-lib": "static-1.35806",
  "bark-lib": "static-1.16815",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6191",
  "react-codemirror": "static-1.10944",
  "embedded-academy-lib": "static-1.15517",
  "hubs-service-types": "static-1.1562",
  "navigation-components": "static-1.18834",
  "getting-started-shared-tasks": "static-1.19238",
  "getting-started-shared-tasks-store": "static-1.18356",
  "onboarding-tours-utils": "static-1.1188",
  "stylex-utils": "static-1.140",
  "trellis-theming": "static-1.1277",
  "react-dnd-compat": "static-1.4920",
  "reporting-client-types": "static-1.2686",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-public": "static-1.7448",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10618",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "highcharts": "static-8.111",
  "trellis-story-utils": "static-1.4811",
  "storybook-react": "static-1.40",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5215",
  "reactive-lib": "static-1.1021",
  "simple-logging-lib": "static-1.3355",
  "FormUrlGenerator": "static-2.5030",
  "sequences-lib": "static-1.8533",
  "FileManagerCore": "static-1.39998",
  "FileManagerLib": "static-1.40139",
  "timezone-utils": "static-2.5547",
  "ui-gdpr-components": "static-1.10625",
  "developer-experience-shared-components": "static-1.10842",
  "immutable-less": "static-1.4953",
  "marketplace-ui-client-types": "static-1.18135",
  "marketplace-ui-common": "static-1.20728",
  "ui-addon-integrations-directory-panel": "static-2.8330",
  "ui-extensibility-client-types": "static-1.4221",
  "ui-universal-auth": "static-1.9408",
  "growth-data-modal": "static-1.5899",
  "growth-onboarding-next-action-utils": "static-1.2686",
  "onboarding-tours-client": "static-1.5336",
  "ui-shepherd-react": "static-3.10573",
  "ui-shepherd-tracker": "static-1.7954",
  "cms-field-types": "static-1.5117",
  "content-icons-ui": "static-1.2366",
  "integrations-lib": "static-1.17035",
  "underscore": "static-1.8",
  "calling-orchestration-schema": "static-1.36835",
  "crm-record-cards-service-types": "static-1.3787",
  "breeze-engine-chat-components": "static-1.715",
  "breeze-engine-core": "static-1.1015",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "content-media-composition-data-lib": "static-1.13240",
  "content-media-compositions": "static-2.17247",
  "media-bridge-lib": "static-1.19408",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16364",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.14977",
  "nest": "static-1.540",
  "amplitude-session-replay-browser": "static-1.60",
  "prosemirror": "static-1.13",
  "sequences-client-types-lib": "static-1.8390",
  "breeze-artifacts-sdk": "static-1.339",
  "audio-components": "static-1.6346",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37650",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4836",
  "video-components": "static-1.14150",
  "video-embed": "static-1.36640",
  "apps-service-types": "static-1.4042",
  "oauth-service-types": "static-1.4541",
  "ai-settings-ui-library": "static-1.8353",
  "nav-meta": "static-1.30471",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1061",
  "unified-auth-core-lib": "static-1.1204",
  "onboarding-data-sync-lib": "static-1.2515",
  "growth-onboarding-next-action-components": "static-1.2714",
  "user-context-client": "static-1.4809",
  "flux-actions": "static-1.368",
  "integrations-error-boundary-lib": "static-1.14450",
  "integrations-tracking-lib": "static-1.5910",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10674",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.922",
  "academy-service-client": "static-1.3990",
  "croppie": "static-2.10",
  "final-form": "static-1.78",
  "SafeStorage": "static-1.4708",
  "trellis-ecosystem": "static-1.7630",
  "ui-addon-video-player": "static-1.9006",
  "wootric-nps": "static-1.7200",
  "content-assistance-lib": "static-1.8201",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4458",
  "simple-data-table": "static-1.3528",
  "InboxConnectUtils": "static-4.15558",
  "meetings-connect-utils-lib": "static-1.7912",
  "universal-page-editor-lib": "static-1.3311",
  "adobe-sign-auth-lib": "static-1.459",
  "ads-unified-auth-lib": "static-1.1375",
  "generic-oauth-auth-lib": "static-1.50",
  "google-sheets-integration-lib": "static-1.1028",
  "microsoft-drive-auth-lib": "static-1.142",
  "surveymonkey-integration-lib": "static-1.485",
  "slack-ui-library": "static-1.10702",
  "ui-coaching-tips": "static-1.29305",
  "hub-http-contrib": "static-1.3342",
  "ui-addon-sales-email": "static-1.5515"
},
  depPathPrefixes: {
  "billing-portal-ui": "/billing-portal-ui/static-1.2101",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.496",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.36",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8334",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10620",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.22",
  "react-dlb": "/react-dlb/static-1.88",
  "reselect": "/reselect/static-3.12",
  "billing-portal-service-types": "/billing-portal-service-types/static-1.1939",
  "commerce-products-lib": "/commerce-products-lib/static-1.10527",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19223",
  "customer-data-objects": "/customer-data-objects/static-1.7995",
  "customer-data-properties": "/customer-data-properties/static-1.52599",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8404",
  "data-fetching-client": "/data-fetching-client/static-1.9958",
  "foundations-assets": "/foundations-assets/static-1.5188",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "/foundations-theming/static-1.4779",
  "framework-data-table": "/framework-data-table/static-2.12552",
  "hub-http": "/hub-http/static-1.6516",
  "HubStyleTokens": "/HubStyleTokens/static-2.11793",
  "I18n": "/I18n/static-7.1673",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.939",
  "metrics-js": "/metrics-js/static-1.9867",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49674",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1457",
  "property-translator": "/property-translator/static-1.5698",
  "purchase-motions-components": "/purchase-motions-components/static-1.6367",
  "quartz-config": "/quartz-config/static-1.1237",
  "quartz-core": "/quartz-core/static-1.6678",
  "quartz-routing": "/quartz-routing/static-1.889",
  "quick-fetch": "/quick-fetch/static-1.4130",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17025",
  "redux": "/redux/static-4.76",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rpc-client-utils": "/rpc-client-utils/static-1.4970",
  "sanitize-text": "/sanitize-text/static-1.8458",
  "smart-property-lib": "/smart-property-lib/static-1.8296",
  "styled-components": "/styled-components/static-2.95",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11286",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11450",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9380",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9839",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18389",
  "UIComponents": "/UIComponents/static-3.8739",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3621",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3736",
  "quartz-webpack": "/quartz-webpack/static-1.3683",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.537",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.36",
  "HeadJS": "/HeadJS/static-2.797",
  "quartz": "/quartz/static-1.7459",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3445",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4294",
  "webpack-env": "/webpack-env/static-1.54",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "commerce-permissions": "/commerce-permissions/static-1.1080",
  "customer-data-tracking": "/customer-data-tracking/static-1.7185",
  "growth-payments-core": "/growth-payments-core/static-1.26180",
  "hs-resources": "/hs-resources/static-1.495",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5180",
  "immer": "/immer/static-1.101",
  "products-iframe-lib": "/products-iframe-lib/static-1.8593",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11002",
  "pulse": "/pulse/static-1.933",
  "transmute": "/transmute/static-2.97",
  "batch-promise": "/batch-promise/static-1.1847",
  "crm_data": "/crm_data/static-4.92830",
  "cssUtils": "/cssUtils/static-1.924",
  "customer-data-associations": "/customer-data-associations/static-1.7630",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13333",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7196",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8226",
  "graphql": "/graphql/static-1.89",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9728",
  "HubStyle": "/HubStyle/static-2.12100",
  "icons": "/icons/static-2.683",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23832",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5557",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8000",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "ui-addon-opt": "/ui-addon-opt/static-4.8667",
  "ui-images": "/ui-images/static-2.1249",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4054",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9717",
  "atom": "/atom/static-1.5390",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2784",
  "calling-global-api": "/calling-global-api/static-1.65625",
  "calling-internal-common": "/calling-internal-common/static-1.31624",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67007",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59301",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4015",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4544",
  "crm-links": "/crm-links/static-1.6633",
  "crm-message-bus": "/crm-message-bus/static-1.43762",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4348",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9947",
  "external-options-client-types": "/external-options-client-types/static-1.4339",
  "file-manager-components": "/file-manager-components/static-1.24499",
  "formula-editor": "/formula-editor/static-1.14770",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5898",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4427",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3910",
  "PatternValidationJS": "/PatternValidationJS/static-1.3196",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4182",
  "property-value-citations": "/property-value-citations/static-1.3213",
  "quartz-i18n": "/quartz-i18n/static-1.1134",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8406",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.142",
  "tiered-pricing": "/tiered-pricing/static-1.1956",
  "topics-actions-lib": "/topics-actions-lib/static-1.469",
  "trial-components-library": "/trial-components-library/static-1.14109",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "user-context": "/user-context/static-1.5423",
  "zustand": "/zustand/static-1.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.36",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2495",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "react-virtualized": "/react-virtualized/static-2.107",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2645",
  "ui-fonts": "/ui-fonts/static-1.1055",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3262",
  "foundations-theming-base": "/foundations-theming-base/static-1.3764",
  "stylex": "/stylex/static-1.41",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13480",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10132",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.127",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reference-resolvers": "/reference-resolvers/static-1.8484",
  "reporting-data": "/reporting-data/static-1.68826",
  "sanitize": "/sanitize/static-1.4775",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5063",
  "hs-locale-management": "/hs-locale-management/static-1.295",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "interframe": "/interframe/static-3.5058",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6051",
  "laboratory-lib": "/laboratory-lib/static-3.7455",
  "merchandise-lib": "/merchandise-lib/static-1.278",
  "onboarding-scopes": "/onboarding-scopes/static-1.6756",
  "purchase-motions-api": "/purchase-motions-api/static-1.6370",
  "signup-constants": "/signup-constants/static-1.19631",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8364",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.74",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hubspotter-http": "/hubspotter-http/static-1.4864",
  "jasmine": "/jasmine/static-4.4616",
  "jasmine-runner": "/jasmine-runner/static-1.6754",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.449",
  "quartz-auth": "/quartz-auth/static-1.1134",
  "quartz-head": "/quartz-head/static-1.1124",
  "quartz-test": "/quartz-test/static-1.1134",
  "quartz-tracking": "/quartz-tracking/static-1.838",
  "trellis-components": "/trellis-components/static-1.2664",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.380",
  "chirp-fetch": "/chirp-fetch/static-1.2197",
  "data-agent-kit": "/data-agent-kit/static-1.651",
  "data-token-picker": "/data-token-picker/static-1.16891",
  "feedback-loader": "/feedback-loader/static-1.29813",
  "markdown-it": "/markdown-it/static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10703",
  "fsm": "/fsm/static-1.4053",
  "policy-lib": "/policy-lib/static-1.7105",
  "react-colorpicker": "/react-colorpicker/static-2.10521",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10766",
  "magpie-lib": "/magpie-lib/static-1.5755",
  "navigation-messaging": "/navigation-messaging/static-1.8161",
  "salesImages": "/salesImages/static-1.565",
  "seat-types-lib": "/seat-types-lib/static-1.727",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4959",
  "event-emitter": "/event-emitter/static-1.1256",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4220",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.315",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.639",
  "sales-views-client-types": "/sales-views-client-types/static-1.4560",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.436",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "crm_universal": "/crm_universal/static-1.22498",
  "customer-data-email": "/customer-data-email/static-1.18528",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8080",
  "superstore": "/superstore/static-1.5061",
  "sassPrefix": "/sassPrefix/static-1.195",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7101",
  "persist-promise": "/persist-promise/static-1.4004",
  "copilot-toolkit": "/copilot-toolkit/static-1.11850",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3364",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6887",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5384",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19260",
  "onboarding-tours": "/onboarding-tours/static-1.17121",
  "stripe-connect-js": "/stripe-connect-js/static-1.76",
  "chatspot-core": "/chatspot-core/static-1.23032",
  "ContentUtils": "/ContentUtils/static-1.69126",
  "calling-error-reporting": "/calling-error-reporting/static-1.31631",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11345",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6839",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2058",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7549",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6744",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10096",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1676",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1737",
  "immerable": "/immerable/static-1.4451",
  "video-components-external": "/video-components-external/static-1.12148",
  "video-data-lib": "/video-data-lib/static-1.35806",
  "bark-lib": "/bark-lib/static-1.16815",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6191",
  "react-codemirror": "/react-codemirror/static-1.10944",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15517",
  "hubs-service-types": "/hubs-service-types/static-1.1562",
  "navigation-components": "/navigation-components/static-1.18834",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19238",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18356",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1188",
  "stylex-utils": "/stylex-utils/static-1.140",
  "trellis-theming": "/trellis-theming/static-1.1277",
  "react-dnd-compat": "/react-dnd-compat/static-1.4920",
  "reporting-client-types": "/reporting-client-types/static-1.2686",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-public": "/usage-tracker-public/static-1.7448",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10618",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "highcharts": "/highcharts/static-8.111",
  "trellis-story-utils": "/trellis-story-utils/static-1.4811",
  "storybook-react": "/storybook-react/static-1.40",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5215",
  "reactive-lib": "/reactive-lib/static-1.1021",
  "simple-logging-lib": "/simple-logging-lib/static-1.3355",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5030",
  "sequences-lib": "/sequences-lib/static-1.8533",
  "FileManagerCore": "/FileManagerCore/static-1.39998",
  "FileManagerLib": "/FileManagerLib/static-1.40139",
  "timezone-utils": "/timezone-utils/static-2.5547",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10842",
  "immutable-less": "/immutable-less/static-1.4953",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18135",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20728",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8330",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4221",
  "ui-universal-auth": "/ui-universal-auth/static-1.9408",
  "growth-data-modal": "/growth-data-modal/static-1.5899",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2686",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5336",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10573",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7954",
  "cms-field-types": "/cms-field-types/static-1.5117",
  "content-icons-ui": "/content-icons-ui/static-1.2366",
  "integrations-lib": "/integrations-lib/static-1.17035",
  "underscore": "/underscore/static-1.8",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36835",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3787",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.715",
  "breeze-engine-core": "/breeze-engine-core/static-1.1015",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13240",
  "content-media-compositions": "/content-media-compositions/static-2.17247",
  "media-bridge-lib": "/media-bridge-lib/static-1.19408",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16364",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.14977",
  "nest": "/nest/static-1.540",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "prosemirror": "/prosemirror/static-1.13",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8390",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.339",
  "audio-components": "/audio-components/static-1.6346",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37650",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4836",
  "video-components": "/video-components/static-1.14150",
  "video-embed": "/video-embed/static-1.36640",
  "apps-service-types": "/apps-service-types/static-1.4042",
  "oauth-service-types": "/oauth-service-types/static-1.4541",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8353",
  "nav-meta": "/nav-meta/static-1.30471",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1061",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1204",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2515",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2714",
  "user-context-client": "/user-context-client/static-1.4809",
  "flux-actions": "/flux-actions/static-1.368",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14450",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5910",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10674",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.922",
  "academy-service-client": "/academy-service-client/static-1.3990",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.78",
  "SafeStorage": "/SafeStorage/static-1.4708",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7630",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9006",
  "wootric-nps": "/wootric-nps/static-1.7200",
  "content-assistance-lib": "/content-assistance-lib/static-1.8201",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4458",
  "simple-data-table": "/simple-data-table/static-1.3528",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15558",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7912",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3311",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.459",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1375",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.50",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1028",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.142",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.485",
  "slack-ui-library": "/slack-ui-library/static-1.10702",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29305",
  "hub-http-contrib": "/hub-http-contrib/static-1.3342",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5515"
}
};
